<template>
  <div :class="fromHome ? 'clavier fromHome' : 'clavier'">
    <v-container fluid>
      <v-row>
        <v-col
          cols="12"
          md="6"
          offset-md="3"
          lg="4"
          offset-lg="4"
          class="clavier-base"
        >
          <template v-if="fromHome">
            <div class="d-flex clavier-tools mb-2">
              <v-col
                cols="3"
                class="text-center pa-0"
                style="height: inherit"
              >
                <div
                  class="touche gris toucheCarrier"
                  :class="{disabled: contactDisabled}"
                  @touchend="contactDisabled ? null : $emit('carrier')"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 1664 1792"
                  >
                    <path
                      :fill="contactDisabled ? '#9e9e9e' : '#454543'"
                      d="M1028 644q0 107-76.5 183T768 903t-183.5-76T508 644q0-108 76.5-184T768 384t183.5 76t76.5 184zm-48 220q46 0 82.5 17t60 47.5t39.5 67t24 81t11.5 82.5t3.5 79q0 67-39.5 118.5T1056 1408H480q-66 0-105.5-51.5T335 1238q0-48 4.5-93.5T358 1046t36.5-91.5t63-64.5t93.5-26h5q7 4 32 19.5t35.5 21t33 17t37 16t35 9T768 951t39.5-4.5t35-9t37-16t33-17t35.5-21t32-19.5zm684-256q0 13-9.5 22.5T1632 640h-96v128h96q13 0 22.5 9.5t9.5 22.5v192q0 13-9.5 22.5t-22.5 9.5h-96v128h96q13 0 22.5 9.5t9.5 22.5v192q0 13-9.5 22.5t-22.5 9.5h-96v224q0 66-47 113t-113 47H160q-66 0-113-47T0 1632V160Q0 94 47 47T160 0h1216q66 0 113 47t47 113v224h96q13 0 22.5 9.5t9.5 22.5v192zm-256 1024V160q0-13-9.5-22.5T1376 128H160q-13 0-22.5 9.5T128 160v1472q0 13 9.5 22.5t22.5 9.5h1216q13 0 22.5-9.5t9.5-22.5z"
                    />
                  </svg>
                </div>
              </v-col>
              <v-col
                cols="3"
                class="text-center pa-0"
                style="height: inherit"
              >
                <div
                  class="touche gris toucheW2S"
                  :class="{disabled: w2sDisabled}"
                  @touchend="w2sDisabled ? null : $emit('w2s')"
                >
                  <v-icon :color="w2sDisabled ? 'grey' : '#454543'">
                    mdi-cloud-sync
                  </v-icon>
                </div>
              </v-col>
              <v-col
                cols="3"
                class="text-center pa-0"
                style="height: inherit"
              >
                <div
                  class="touche gris toucheBadge"
                  @touchend="$emit('badge')"
                >
                  <v-icon color="#454543">
                    mdi-account-card-details
                  </v-icon>
                </div>
              </v-col>
              <v-col
                cols="3"
                class="text-center pa-0"
                style="height: inherit"
              >
                <div
                  class="touche gris toucheScan"
                  :class="{disabled: scanDisabled}"
                  @touchend="scanDisabled ? null : $emit('scan')"
                >
                  <v-icon :color="scanDisabled ? 'grey' : '#454543'">
                    mdi-credit-card-scan
                  </v-icon>
                </div>
              </v-col>
            </div>
          </template>

          <v-row no-gutters>
            <v-col
              cols="3"
              class="text-center"
            >
              <div
                class="touche touche1"
                @touchend="$emit('add', 1)"
              >
                <span class="signe">1</span>
              </div>
            </v-col>
            <v-col
              cols="3"
              class="text-center"
            >
              <div
                class="touche touche2"
                @touchend="$emit('add', 2)"
              >
                <span class="signe">2</span>
              </div>
            </v-col>
            <v-col
              cols="3"
              class="text-center"
            >
              <div
                class="touche touche3"
                @touchend="$emit('add', 3)"
              >
                <span class="signe">3</span>
              </div>
            </v-col>
            <v-col
              cols="3"
              class="text-center"
            >
              <div
                v-long-press="menuLongPress"
                class="touche gris"
                @touchend="$emit('menu')"
              >
                <span class="signe" />
              </div>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col
              cols="3"
              class="text-center"
            >
              <div
                class="touche touche4"
                @touchend="$emit('add', 4)"
              >
                <span class="signe">4</span>
              </div>
            </v-col>
            <v-col
              cols="3"
              class="text-center"
            >
              <div
                class="touche touche5"
                @touchend="$emit('add', 5)"
              >
                <span class="signe">5</span>
              </div>
            </v-col>
            <v-col
              cols="3"
              class="text-center"
            >
              <div
                class="touche touche6"
                @touchend="$emit('add', 6)"
              >
                <span class="signe">6</span>
              </div>
            </v-col>
            <v-col
              cols="3"
              class="text-center"
            >
              <div
                class="touche rouge toucheCancel"
                @touchend="$emit('cancel')"
              >
                <img
                  :src="AppImages.pictoCroix"
                  alt="cruse"
                  width="20"
                >
              </div>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col
              cols="3"
              class="text-center"
            >
              <div
                class="touche touche7"
                @touchend="$emit('add', 7)"
              >
                <span class="signe">7</span>
              </div>
            </v-col>
            <v-col
              cols="3"
              class="text-center"
            >
              <div
                class="touche touche8"
                @touchend="$emit('add', 8)"
              >
                <span class="signe">8</span>
              </div>
            </v-col>
            <v-col
              cols="3"
              class="text-center"
            >
              <div
                class="touche touche9"
                @touchend="$emit('add', 9)"
              >
                <span class="signe">9</span>
              </div>
            </v-col>
            <v-col
              cols="3"
              class="text-center"
            >
              <div
                class="touche jaune toucheDel"
                @touchend="$emit('del')"
              >
                <img
                  :src="AppImages.pictoInferieur"
                  alt="min"
                  width="20"
                >
              </div>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col
              cols="3"
              class="text-center"
            >
              <div
                class="touche toucheFunc"
                @touchend="$emit('func')"
              >
                <span class="signe">F</span>
              </div>
            </v-col>
            <v-col
              cols="3"
              class="text-center"
            >
              <div
                class="touche touche0"
                @touchend="$emit('add', 0)"
              >
                <span class="signe">0</span>
              </div>
            </v-col>
            <v-col
              cols="3"
              class="text-center"
            >
              <div
                class="touche touche00"
                @touchend="$emit('add', 0, true)"
              >
                <span class="signe">00</span>
              </div>
            </v-col>
            <v-col
              cols="3"
              class="text-center"
            >
              <div
                class="touche vert toucheValid"
                @touchend="$emit('valid')"
              >
                <img
                  :src="AppImages.pictoRond"
                  alt="valid"
                  width="20"
                >
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { AppImages } from '@/modules/Images'

export default {
  name: 'KeyboardBaseIngenico',

  props: {
    useListener: { type: Boolean, default: true },
    fromHome: { type: Boolean, default: false },
    contactDisabled: { type: Boolean, default: false },
    w2sDisabled: { type: Boolean, default: false },
    scanDisabled: { type: Boolean, default: false }
  },

  data () {
    return {
      AppImages
    }
  },

  watch: {
    useListener (newVal, oldVal) {
      if (newVal === true) {
        this.startListener()
      } else {
        this.stopListener()
      }
    }
  },

  mounted () {
    if (this.useListener) this.startListener()
  },

  beforeDestroy () {
    if (this.useListener) this.stopListener()
  },

  methods: {
    startListener () {
      window.addEventListener('keyup', this.keyup, false)
    },
    stopListener () {
      window.removeEventListener('keyup', this.keyup, false)
    },
    keyup (e) {
      let key = parseInt(e.key)
      // is a number
      if (!isNaN(key)) {
        this.$emit('add', key)
      } else {
        switch (e.key) {
          case 'Enter':
            this.$emit('valid')
            break
          case 'Backspace':
            this.$emit('del')
            break
          case 'Escape':
            this.$emit('cancel')
            break
          case '*':
            this.$emit('menu')
            break
          case 'f':
            this.$emit('func')
            break
          default:
            break
        }
      }
    },
    menuLongPress () {
      this.$emit('menu-longpress')
    }
  }
}
</script>

<style scoped>
.row, .col {
  height: 80px;
}
</style>
